import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Routes from '@/router/routes';

export interface ITableProps {
  name: string;
  owner: string;
  user_count: number;
  plan: string;
  status: string;
  tellets: number;
}

export const OrganizationsColumns = () => {
  const columns: ColumnDef<ITableProps>[] = [
    {
      accessorKey: 'name',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Name
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => (
        <div className="flex items-center gap-3">
          <Link
            className="font-medium transition-all ease-in-out text-primary hover:underline"
            to={`${Routes.super_admin_dashboard_single_organization.path}/id`}
          >
            {row?.getValue('name')}
          </Link>
        </div>
      ),
    },
    {
      accessorKey: 'owner',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Owner
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('owner')}</>,
    },
    {
      accessorKey: 'user_count',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          User Count
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('user_count')}</>,
    },
    {
      accessorKey: 'plan',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Plan
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => (
        <div className="w-fit">
          <p className="px-4 font-medium text-purple-800 py-0.5 bg-purple-200 rounded-full">
            {row.getValue('plan')}
          </p>
        </div>
      ),
    },
    {
      accessorKey: 'status',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Status
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => (
        <div className="w-fit">
          <p className="px-4 font-medium text-green-800 py-0.5 bg-green-200 rounded-full">
            {row.getValue('status')}
          </p>
        </div>
      ),
    },
    {
      accessorKey: 'tellets',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Tellets
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('tellets')}</>,
    },
  ];
  return columns;
};
